export default __webpack_public_path__ + "static/media/AreaPrivada.cd991e69.svg";